import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class Permission {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  displayName!: string;
}
